"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, Suspense } from "react";
import { ArrowUpDown, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import SortDropdown from "@/components/filter-panel/sort/dropdown";
import { SORT_BY_OPTIONS } from "@/constants/filter";
import { useSearchParams } from "next/navigation";
interface ResponsiveSortFilterProps {
  isVisible?: boolean;
  onSortSelect?: () => void;
}
const ResponsiveSortFilterContent = t0 => {
  const $ = _c(15);
  const {
    isVisible: t1,
    onSortSelect
  } = t0;
  const isVisible = t1 === undefined ? true : t1;
  const [activeDrawer, setActiveDrawer] = useState(null);
  const searchParams = useSearchParams();
  let t2;
  if ($[0] !== searchParams) {
    t2 = searchParams.get("sort_by") || "";
    $[0] = searchParams;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const selectedSort = t2;
  let t3;
  if ($[2] !== isVisible) {
    t3 = isVisible && <motion.div initial={{
      y: 100,
      x: "-50%",
      opacity: 0
    }} animate={{
      y: 0,
      x: "-50%",
      opacity: 1
    }} exit={{
      y: 100,
      x: "-50%",
      opacity: 0
    }} className="lg:hidden fixed bottom-6 left-1/2 -translate-x-1/2 z-[45] flex items-center justify-center w-[120px] bg-[#037A6A] shadow-[0_8px_30px_rgb(3,122,106,0.3)] border border-[#037A6A] rounded-full h-12 overflow-hidden pointer-events-auto"><button onClick={() => setActiveDrawer("sort")} className="flex-1 h-full flex items-center justify-center gap-2 transition-all active:scale-95 font-lora font-bold text-sm uppercase tracking-wider text-white hover:bg-white/10 active:bg-white/20"><ArrowUpDown size={18} className="text-white" />Sort</button></motion.div>;
    $[2] = isVisible;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <AnimatePresence>{t3}</AnimatePresence>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== activeDrawer || $[7] !== onSortSelect || $[8] !== selectedSort) {
    t5 = activeDrawer === "sort" && <div className="fixed inset-0 z-[100] lg:hidden flex flex-col justify-end"><motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setActiveDrawer(null)} className="fixed inset-0 bg-black/60 z-[140] backdrop-blur-[4px] touch-none" transition={{
        duration: 0.3
      }} /><motion.div initial={{
        y: "100%"
      }} animate={{
        y: 0
      }} exit={{
        y: "100%"
      }} transition={{
        type: "spring",
        damping: 32,
        stiffness: 300,
        mass: 1
      }} className="w-full bg-white z-[150] rounded-t-[32px] overflow-hidden flex flex-col max-h-[85vh] shadow-[0_-8px_30px_rgba(0,0,0,0.1)]"><div className="flex justify-center pt-3 pb-1"><div className="w-12 h-1.5 bg-stone-200 rounded-full" /></div><div className="relative w-full"><button onClick={() => setActiveDrawer(null)} className="absolute top-2 right-4 text-stone-400 z-50 p-2 hover:bg-stone-50 rounded-full transition-colors"><X size={20} /></button><div className="w-full pt-6 px-6 pb-8 overflow-y-auto no-scrollbar scrollbar-hide"><h2 className="text-[18px] font-outfit font-extrabold text-left text-[#303030] mb-6 tracking-tight">Sort By</h2><div className="flex flex-col items-start w-full"><SortDropdown options={SORT_BY_OPTIONS} selectedOption={selectedSort} onOptionChange={() => {
                setActiveDrawer(null);
                onSortSelect?.();
              }} isMobile={true} /></div></div></div></motion.div></div>;
    $[6] = activeDrawer;
    $[7] = onSortSelect;
    $[8] = selectedSort;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <AnimatePresence>{t5}</AnimatePresence>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <>{t4}{t6}</>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
const ResponsiveSortFilter = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Suspense fallback={null}><ResponsiveSortFilterContent {...props} /></Suspense>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default ResponsiveSortFilter;